module.exports = __webpack_public_path__ + "img/slide-4.168f2e34.png";